
export function NewEliteLandingPlanSelectorSkeleton() {
    return (
        <div className='space-y-5 animate-pulse'>
            <div className='space-y-3 px-5'>
                <div className='rounded-xl bg-white px-4 py-[18px]'>
                    <div className='flex items-center justify-between'>
                        <div className='flex items-center gap-3'>
                            <div className='size-5 rounded-full bg-[#E9E3E1]' />
                            <div className='space-y-2'>
                                <div className='h-3 w-16 rounded bg-[#E9E3E1]' />
                                <div className='h-3 w-20 rounded bg-[#F2ECEA]' />
                            </div>
                        </div>
                        <div className='space-y-2 text-right'>
                            <div className='h-3 w-24 rounded bg-[#E9E3E1]' />
                            <div className='h-3 w-16 rounded bg-[#F2ECEA]' />
                        </div>
                    </div>
                </div>
                <div className='rounded-xl bg-white px-4 py-[18px]'>
                    <div className='flex items-center justify-between'>
                        <div className='flex items-center gap-3'>
                            <div className='size-5 rounded-full bg-[#E9E3E1]' />
                            <div className='h-3 w-16 rounded bg-[#E9E3E1]' />
                        </div>
                        <div className='h-3 w-24 rounded bg-[#E9E3E1]' />
                    </div>
                </div>
            </div>

            <div className='mx-5 rounded-xl bg-[#CDC5C2] py-4'>
                <div className='mx-auto h-4 w-44 rounded bg-[#B7AFAC]' />
            </div>

            <div className='mx-5 flex items-start gap-3'>
                <div className='mt-0.5 size-5 rounded-full bg-[#E0DAD8]' />
                <div className='flex-1 space-y-2'>
                    <div className='h-3 w-full rounded bg-[#E0DAD8]' />
                    <div className='h-3 w-2/3 rounded bg-[#EDE6E3]' />
                </div>
            </div>
        </div>
    )
}
